<template>
    <h1
        v-if="!isFrontpage"
        class="subpage-header"
        >
        {{ t('lanarettur_lantokurettur') }}
    </h1>
    
<BaseCard :loading="!user" skeleton-type="paragraph" :minHeight="160" class="lanrettindi-card">
  <RouterLink to="/nanar-lan" class="linkbox-card__link">
    <h2 class="linkbox-card__title">{{ t('lanarettur_lantokurettur') }}</h2>
    <div v-if="user?.sjodfelagi || user?.hasSereignRettindi">
      <p class="linkbox-card__text">{{ t('lanarettur_cantake_text') }}</p>
    </div>
    <div v-else>
      <p class="linkbox-card__text">{{ t('lanarettur_cannottake_text') }}</p>
    </div>
  </RouterLink>

  <div v-if="!user?.sjodfelagi && !user?.hasSereignRettindi && !isFrontpage" class="mt-4">
    <button class="base-button" @click="showDetailText = !showDetailText">
      {{ t('lanarettur_rules') }}
    </button>
    <p class="text-muted mt-2">{{ t('lanarettur_rules_details') }}</p>
    <p v-if="showDetailText" class="text-bold mt-2">{{ t('lanarettur_rules_details2') }}</p>
  </div>
</BaseCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/useAuthStore'
import BaseCard from '@/components/shared/BaseCard.vue'

const { t } = useI18n()
const authStore = useAuthStore()

const showDetailText = ref(false)
const user = computed(() => authStore.authUser)

const props = defineProps<{
  isFrontpage?: boolean
}>()
</script>

<style scoped lang="scss">
@use "@/scss/settings/variables" as var;
@use "@/scss/settings/media-queries" as mq;

.lanrettindi-card {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  a {
    color: var.$color-text;
    text-decoration: none;
  }

  @include mq.mobile {
    padding: 16px;
    gap: 12px;
  }
}

.linkbox-card__title {
  font-size: 20px;
  font-weight: 700;
  color: var(--v-theme-primary-dark);

  @include mq.mobile {
    font-size: 18px;
  }
}

.linkbox-card__text {
  font-size: 16px;
  color: var(--v-theme-on-background);

  @include mq.mobile {
    font-size: 14px;
  }
}

.base-button {
  background: var(--v-theme-primary-dark);
  color: white;
  padding: 12px 20px;
  text-align: center;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-right: 12px;
  display: inline-block;

  @include mq.mobile {
    padding: 10px 16px;
    font-size: 14px;
    margin-right: 0;
    width: 100%;
  }
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  @include mq.mobile {
    flex-direction: column;
    gap: 8px;
  }
}

.text-muted,
.text-bold {
  @include mq.mobile {
    font-size: 14px;
  }
}

body.dark-mode {
  .linkbox-card__title {
    color: var.$color-primary-dark;
  }

  .linkbox-card__text {
    color: var.$color-text-dark;
  }

  .lanrettindi-card a {
    color: var.$color-text-dark;
  }
}
</style>
